import { render, staticRenderFns } from "./Q4sHowItWorks.vue?vue&type=template&id=9dabaec8&scoped=true"
import script from "./Q4sHowItWorks.vue?vue&type=script&lang=ts"
export * from "./Q4sHowItWorks.vue?vue&type=script&lang=ts"
import style0 from "./Q4sHowItWorks.vue?vue&type=style&index=0&id=9dabaec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dabaec8",
  null
  
)

export default component.exports